var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSugarFree2 = function SvgSugarFree2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SugarFree2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#SugarFree2_svg__b)",
    d: "M21.783.711C10.32.711.993 10.035.993 21.501s9.324 20.79 20.79 20.79 20.79-9.328 20.79-20.79S33.245.711 21.783.711m0 39.354c-4.67 0-8.933-1.747-12.201-4.607l3.965-3.97a1.11 1.11 0 0 0 0-1.574 1.11 1.11 0 0 0-1.575 0L7.999 33.89c-2.961-3.288-4.78-7.627-4.78-12.39 0-10.235 8.329-18.564 18.564-18.564 4.763 0 9.097 1.819 12.39 4.78l-3.902 3.906a1.11 1.11 0 0 0 0 1.575 1.104 1.104 0 0 0 1.57 0L35.736 9.3c2.86 3.268 4.608 7.526 4.608 12.201 0 10.235-8.329 18.564-18.564 18.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SugarFree2_svg__c)",
    d: "m21.785 10.545-.395.18-9.727 4.377-.32.134a.42.42 0 0 0-.255.387v11.814c0 .152.08.29.214.366l.273.151 9.727 5.41.282.16a.42.42 0 0 0 .411 0l.281-.16 9.728-5.41.273-.151a.43.43 0 0 0 .214-.366V15.623c0-.168-.1-.324-.256-.387l-.32-.134-9.727-4.376-.394-.181zm.172 2.205 6.498 2.906c.323.143.332.601.017.76l-6.498 3.247a.42.42 0 0 1-.374 0l-6.497-3.246a.422.422 0 0 1 .017-.76l6.497-2.907c.11-.05.235-.05.345 0zm-8.316 5.12 6.943 3.469a.42.42 0 0 1 .23.374v8.42a.42.42 0 0 1-.625.366l-6.943-3.851a.42.42 0 0 1-.214-.366v-8.038c0-.311.328-.517.61-.374m16.897.374v8.038a.42.42 0 0 1-.214.366l-6.943 3.851a.42.42 0 0 1-.626-.365v-8.421a.41.41 0 0 1 .231-.374l6.943-3.47a.42.42 0 0 1 .609.375"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SugarFree2_svg__b",
    x1: 11.388,
    x2: 39.108,
    y1: 0.711,
    y2: 42.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SugarFree2_svg__c",
    x1: 16.439,
    x2: 32.195,
    y1: 10.545,
    y2: 32.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SugarFree2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.786.498h42v42h-42z"
  })))));
};
export default SvgSugarFree2;